/*
 * Where: src/layouts/MainLayout.js
 * What: Shared layout template for all pages.
 * Why: Keep common header/footer wiring in one place.
 */
import React from 'react';
import SiteFooter from '../components/organisms/SiteFooter';
import SiteHeader from '../components/organisms/SiteHeader';

function MainLayout({ currentPath, onNavigate, children }) {
    return (
        <div className="app-shell">
            <SiteHeader currentPath={currentPath} onNavigate={onNavigate} />
            <main className="site-main">
                <div className="container">{children}</div>
            </main>
            <SiteFooter />
        </div>
    );
}

export default MainLayout;
